import type { ElementType, ReactNode } from 'react'
import { cn } from '../../lib/cn'

type ContainerProps = {
  children: ReactNode
  className?: string
  /** `div` by default; pass `section`, `header`, `footer`, … for real semantics. */
  as?: ElementType
}

/**
 * The one horizontal rhythm on the site: full width, capped at the container
 * token (1440px), gutters that grow with the breakpoint. Docs/06 §5.
 */
export const Container = ({ children, className, as: Tag = 'div' }: ContainerProps) => (
  <Tag className={cn('mx-auto w-full max-w-container px-4 sm:px-6 lg:px-8', className)}>
    {children}
  </Tag>
)
